<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" style="margin-left: 12px" @click="addHandle()">添加</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table ref="table" :columns="columns" :data-source="list" bordered :pagination="false" :scroll="{ y: 490 }"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :rowKey="(record, index) => record.id"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)">
        <span slot="reveal" slot-scope="text, record">
          <a-switch :checked="(record.ifOpen == 0) ? true : false" @change="onRevealChangeUpdate(record)" />
        </span>
        <span slot="color" slot-scope="text, record">
          <div class="line" v-bind:style="{ background: record.pipelineColor, height: (record.lineWidth * 2) + 'px' }">
          </div>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="Handle(record)">编辑</a>
        </span>
      </a-table>

      <a-modal title="新增" width="50%" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
        <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="属性类型">

            <a-input placeholder="请输入管类名称"
              v-decorator="['tubeClassName', { rules: [{ required: true, message: '请输入管类名称' }] }]" />
          </a-form-item>
          <a-form-item label="管类编号">
            <a-input placeholder="请输入管类编号"
              v-decorator="['tubeClassCode', { rules: [{ required: true, message: '请输入管类编号' }] }]" />
          </a-form-item>
          <a-form-item label="是否显示">
            <a-switch @change="onRevealChange" v-decorator="['ifOpen', { valuePropName: 'checked' }]" />
          </a-form-item>
          <a-form-item label="管类颜色">
            <a-button v-decorator="['pipelineColor']" v-bind:style="{ background: color }"
              @click="isShowColors = !isShowColors"></a-button>
          </a-form-item>
          <a-form-item label="管类线宽">
            <a-input placeholder="请输入管类线宽"
              v-decorator="['lineWidth', { rules: [{ required: true, message: '请输入管类线宽' }] }]" />
          </a-form-item>
        </a-form>
        <div v-show="isShowColors" class="color-select-layer">
          <sketch-picker v-model="color" @input="colorValueChange"></sketch-picker>
          <div style="margin-left: 8px;">
            <div style="display: inline-block;">
              <span class="color-title">新色</span>
              <div class="color-div" v-bind:style="{ background: color }"></div>
            </div>
            <div style="display: inline-block;">
              <span class="color-title">现色</span>
              <div class="color-div" v-bind:style="{ background: oldColor }"></div>
            </div>
            <a-button style="margin-left: 8px; margin-bottom: 8px;" @click="isShowColors = false">确认</a-button>
            <div class="color-reset" @click="colorReset"></div>
          </div>
        </div>
      </a-modal>

      <!-- 统一线宽 -->
      <a-modal title="统一线宽" width="50%" v-model="unifyLineWidthVisible" @ok="lineWidthhandleOk"
        @cancel="lineWidthhandleCancel">
        <a-form :form="lineWidthForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="线宽长度">
            <a-input placeholder="请输入统一线宽长度"
              v-decorator="['lineWidth', { rules: [{ required: true, message: '请输入统一线宽长度!' }] }]" />
          </a-form-item>
        </a-form>
      </a-modal>

    </a-card>
  </div>

</template>

<script>
import { Sketch } from 'vue-color'
import mixinViewModule from '@/mixin/common'

const columns = [
  {
    title: '属性类型',
    dataIndex: 'tubeClassCode'
  },
  {
    title: '判断类型',
    dataIndex: 'tubeClassName'
  },
  {
    title: '是否启用',
    dataIndex: 'ifOpen',
    scopedSlots: { customRender: 'reveal' }
  },
  {
    title: '规则',
    dataIndex: 'lineWidth'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 150,
    scopedSlots: { customRender: 'action' }
  }
]
const list = [];
export default {
  components: {
    'sketch-picker': Sketch
  },
  mixins: [mixinViewModule],
  name: 'TubingSetting',
  data () {
    return {
      list,
      columns,
      addUrl: '/gis-manager/foundation/tube/add',
      updateUrl: '/gis-manager/foundation/tube/update',
      queryUrl: '/gis-manager/foundation/tube/list',
      queryOneUrl: '/gis-manager/foundation/tube/edit',
      deleteUrl: '/gis-manager/foundation/tube/remove',
      unifyLineWidthUrl: '/gis-manager/foundation/tube/line/width',
      unifyShowUrl: '/gis-manager/foundation/tube/show',
      isShowColors: false,
      unifyLineWidthVisible: false,
      color: '#3f3f3f',
      oldColor: '#3f3f3f',
      updataId: '',
      ifOpen: '1',
      needPage: false,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      lineWidthForm: this.$form.createForm(this, { name: 'lineWidth' })
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        let addOrUpdataUrl = this.addUrl
        if (this.updataId != '') {
          addOrUpdataUrl = this.updateUrl
          values.id = this.updataId
        }
        values.pipelineColor = this.color
        values.ifOpen = this.ifOpen
        console.log(values);
        if (!err) {
          this.$http.post(addOrUpdataUrl, values).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.message)
              this.addOrUpdateVisible = false
              this.isShowColors = false
              this.updataId = ''
              this.resetList()
            } else {
              this.$message.error('操作失败')
            }
          })
        }
      })
    },
    onRevealChange (e) {
      if (e) {
        this.ifOpen = '0'
      } else {
        this.ifOpen = '1'
      }
    },
    onRevealChangeUpdate (e) {
      if (e.ifOpen == '0') {
        e.ifOpen = '1'
      } else {
        e.ifOpen = '0'
      }
      this.$http.post(this.updateUrl, e).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.message)
          this.resetList()
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    handleCancel (e) {
      console.log('Clicked cancel button')
      this.color = '#3f3f3f'
      this.isShowColors = false
      this.visible = false
      this.disabled = false
      this.changedisabled = true
    },
    addHandle () {
      this.color = '#3f3f3f'
      this.ifOpen = 1
      this.addOrUpdateHandle()
    },
    Handle (record) {
      console.log(record);
      this.disabled = true
      this.color = record.pipelineColor
      this.ifOpen = record.ifOpen
      this.oldColor = record.pipelineColor
      this.updataId = record.id
      this.addOrUpdateHandle(record.id)
      this.showModal()
      this.resetList()
    },
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http.get(`${this.queryOneUrl}/${this.currentId}`).then(({
          data
        }) => {
          if (data.ifOpen == '0') {
            data.ifOpen = true
          } else {
            data.ifOpen = false
          }
          this.addOrUpdateForm.setFieldsValue({
            tubeClassName: data.tubeClassName,
            pipelineColor: data.pipelineColor,
            tubeClassCode: data.tubeClassCode,
            lineWidth: data.lineWidth,
            ifOpen: data.ifOpen
          })
        }).catch(() => { })
      }
    },
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      this.selectedRows = this.selectedRows.map(str => parseInt(str, 10));
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.post(_this.deleteUrl,
            _this.selectedRows
          ).then((res) => {
            if (res.code === 0) {
              _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
              _this.selectedRows = []
              _this.resetList()
              _this.queryList()
            }
          }).catch(() => { })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        }
      })
    },
    unifiedWireFrame () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要统一修改的数据')
      }
      this.unifyLineWidthVisible = true
    },
    addShow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要统一显示的数据')
      }
      const _this = this
      this.selectedRows = this.selectedRows.map(str => parseInt(str, 10));
      console.log(_this.selectedRows)
      this.$confirm({
        title: `统一显示提醒`,
        content: `您确认要统一显示选择${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.post(_this.unifyShowUrl,
            _this.selectedRows
          ).then((res) => {
            if (res.code === 0) {
              _this.$message.success(`共显示${_this.selectedRows.length}条数据`)
              _this.selectedRows = []
              _this.resetList()
              _this.queryList()
            }
          }).catch(() => { })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消操作')
        }
      })
    },
    //统一线宽
    lineWidthhandleOk (e) {
      this.lineWidthForm.validateFields((err, values) => {
        values.ids = this.selectedRows.map(str => parseInt(str, 10))
        if (!err) {
          this.$http.post(this.unifyLineWidthUrl, values).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.message)
              this.unifyLineWidthVisible = false
              this.isShowColors = false
              this.updataId = ''
              this.resetList()
            } else {
              this.$message.error('修改失败')
            }
          })
        }
      })
    },
    lineWidthhandleCancel () {
      this.unifyLineWidthVisible = false
    },
    showModal () {
      this.visible = true
    },
    //重置颜色
    colorReset () {
      this.color = this.oldColor
    },
    // 颜色输入框点击事件处理
    colorInputClick () {
      this.isShowColors = !this.isShowColors
    },
    // 颜色值改变事件处理
    colorValueChange (val) {
      // 取颜色对象的十六进制值
      this.color = val.hex
      console.log(this.color);
    },
  }

}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 99vh;
  // border: 1px solid red;
}

/* 横线 */
.line {
  margin: 0 auto;
  width: 80%;
  height: 3px;
  margin-top: -0.5em;
  position: relative;
  text-align: center;
}

.table-page-search-wrapper {
  margin-bottom: 20px;
}

.color-title {
  text-align: center;
  display: inline-block;
}

.color-reset {
  width: 20px;
  height: 20px;
  background-image: url('../../../assets/collectionMappingSystem/colorReset.png');
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  margin: 5px 5px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
}

.color-div {
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin: 2px 5px;
  vertical-align: top;
  cursor: pointer;
  width: 16px;
  height: 16px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
}

.color-select-layer {
  position: absolute;
  z-index: 999;
  top: 22vh;
  left: 14vw;
  background-color: white;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.15);
}

/deep/ .vc-sketch {
  box-shadow: none;
}

/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>